import { render, staticRenderFns } from "./room.vue?vue&type=template&id=201c6d38&scoped=true"
import script from "./room.vue?vue&type=script&lang=js"
export * from "./room.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c6d38",
  null
  
)

export default component.exports